import { StyleSheet } from 'react-native';
import { Neutrals } from 'src/theme-v2/colors';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const style = StyleSheet.create({
  body: {
    gap: Spacing.Compact,
    alignItems: 'center',
  },
  description: {
    ...textLatoStyleDS.BodyRegularMd,
    textAlign: 'center',
    color: Neutrals.neutralGreys.GreyNatural850,
  },
  subDescription: {
    maxWidth: 336,
    alignItems: 'center',
  },
  subDescriptionTail: {
    fontWeight: '700',
  },
});
